import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Gallery from "../pages/gallery/page";
import About from "../pages/about/page";
import Booking from "../pages/booking/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/booking",
    element: <Booking />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
